import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface ExactPayTooltipProps {
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
}

const ExactPayTooltip: React.FC<ExactPayTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip
      css={css`
        height: auto;
        display: inline-block;
        vertical-align: middle;
      `}
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
    >
      <p>
        {translate(
          "Exact Pay limits a virtual card's use to a single transaction that must match the set credit limit. Once the card is used, it will become inactive and unusable.",
        )}
      </p>
    </Tooltip>
  )
}

export default ExactPayTooltip
